import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController } from 'ionic-angular';

import { Master  } from '@providers/asset/index';

@Component({
  selector: 'page-asset',
  templateUrl: 'page.html'
})
export class AssetPage {

  List: any = [];
  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController
  ) {

  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { };
    this.masterApi.getAsset(params).subscribe((resp:any) => {
      this.List = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  select(){
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/asset/page.ts